import { Platform } from 'react-native';
import { AxiosRequestConfig } from 'axios';

import { Currency, Result } from '@src/api/types';

import Client from './client';

type Response = {
  readonly result: Result;
  readonly status: number;
  readonly content: {
    link: string;
    result: string;
  };
  // readonly payment: {
  //   currency: Currency;
  //   data: string;
  //   paymentId: number;
  //   price: number;
  //   transactionId: number;
  // };
  // readonly paymentStatus: 'SUCCESS' | 'NO_BALANCE' | 'NO_BALANCE_NO_REDIRECT';
  // readonly redirect: {
  //   currency: Currency;
  //   price: number;
  //   type: 'EXTERNAL';
  //   url: string;
  // };
};

export default (
  id: string,
  primeId?: string,
  immigrationId?: string,
  config?: AxiosRequestConfig
) => {
  return Client.post<Response>(
    `/ps/v1/plans/pay`,
    {
      device: 'PWA',
      immigrationGuideId: immigrationId,
      planId: id,
      primeId: primeId,
      type: 'PAYMENT',
      upgradeAccess: false,
      callbackURL:
        Platform.OS !== 'web'
          ? 'youtopin:///prime/plans/'
          : 'http://mobile.youtopin.com/prime/plans/',
    },
    config
  );
};
